export const headquarter = {
  bairro: "JARDIM DA SAUDE",
  cep: "04125070",
  cidade: "SAO PAULO",
  endereco: "RUA FRANCISCA EMILIA, 82",
  estado: "SP",
  filial: "1",
  latitude: -23.60046,
  longitude: -46.6179,
  nome: "SP - MATRIZ",
};
